<template>
    <div>
        <div class="container">
            <div>
                请选择考试任务：
                <div class="select">
                    <el-select v-model="project_id">
                        <el-option v-for="(item,index) in project_list" :key="index"
                            :label="item.project_name"
                            :value="item.project_id"
                        ></el-option>
                    </el-select>
                </div>
				<div class="select">
					<el-select @change="changeTask" v-model="task_id">
						<el-option v-for="(item,index) in task_list" :key="index"
							:label="item.task_name"
							:value="item.task_id"
						></el-option>
					</el-select>
				</div>
                <!-- <el-dropdown split-button  @command="changeTask">
                    {{tasklist[index] && tasklist[index].task_name || ' ' }}
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in tasklist" :key="index"  :command="index" @click="changeTask">{{
                            item.task_name }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
            <div class="tip" v-if="msg != ''">
                <span class="el-icon-bell"></span>
                {{ msg }}
            </div>
            <div v-if="msg == ''" class="box" >
                <div id="printTest">
                    <div v-html = "content"></div>
                </div>
            </div>
            <div class="t_center" v-if="msg == ''">
                <el-button type="primary" v-print="'#printTest'" >打印</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {},
        data() {
            return {
                index: '',
                tasklist: [],
                msg: "",
                content: "",
				project_id:'',
				task_id:'',
				task_list:[],
				project_list:[],
				task:[]
            }
        },
        created() {
            this.$store.dispatch("task/getTaskList", {}).then(res => {
                this.tasklist = res.data;
				if(res.data.project_list){
					this.project_list=res.data.project_list
				}
				if(res.data.task_list){
					this.task=res.data.task_list
                }
                if (res.data.length > 0) {
                    this.msg = "请选择考试任务"
                } else {
                    this.msg = "暂无任务";
                }
            });
        },
		watch:{
			project_id:function(news,olds){
				if(news){
					this.task_list=[]
					this.task.forEach(item=>{
						if(item.project_id==news){
							this.task_list.push(item)
						}
					})
				}
				if(news!=olds){
					this.task_id=''
				}
			}
		},
        methods: {
			//考试任务列表
			changeTask(index){
				this.getPermitCardInfo(this.task_id);
			},
			//获取准考证信息
            getPermitCardInfo(task_id) {
                this.$store.dispatch("task/getPermitCardInfo", {task_id:task_id }).then(res => {
                    if(res.flag == 0){
                        this.msg = res.msg;
                    }else{
                        if(res.data.isPrintTime == 0){
                            this.msg = res.data.msg;
                        }else{
                            this.msg = '';
                            this.content = res.data.content;
                        }
                    }
                })
            }
        },
    }
</script>
<style lang='scss' scoped>
.select{width:300px;display:inline-block;margin-right: 10px;}
.tip {
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #a8cfff;
    span {
        display: block;
        font-size: 190px;
        margin: 20px auto;
    }
}
.box{
    padding: 20px;
    border: 1px solid #dcdcdc;
    overflow-y: auto;
    box-sizing: border-box;
    margin-top: 10px;
    min-height:calc(100vh - 300px);
}
.t_center{margin-top:10px;}
</style>